export default "__VITE_ASSET__d67d81af__"